export const passkeysSupported = () =>
  typeof window !== "undefined" &&
  "PublicKeyCredential" in window &&
  typeof PublicKeyCredential.parseCreationOptionsFromJSON === "function"

const credentialJson = (credential: Credential | null) => {
  if (!(credential instanceof PublicKeyCredential)) {
    throw new Error("No passkey was selected")
  }
  return JSON.stringify(credential.toJSON())
}

export const createPasskey = async (optionsJson: string) => {
  const publicKey = PublicKeyCredential.parseCreationOptionsFromJSON(JSON.parse(optionsJson))
  return credentialJson(await navigator.credentials.create({ publicKey }))
}

export const getPasskey = async (optionsJson: string) => {
  const publicKey = PublicKeyCredential.parseRequestOptionsFromJSON(JSON.parse(optionsJson))
  return credentialJson(await navigator.credentials.get({ publicKey }))
}
